function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9927 7.88834L5.20768 13.6735C5.07377 13.8073 5 13.9859 5 14.1764C5 14.3668 5.07377 14.5454 5.20768 14.6793L5.63361 15.1053C5.91116 15.3825 6.36224 15.3825 6.63936 15.1053L11.4973 10.2473L16.3606 15.1107C16.4945 15.2445 16.6731 15.3184 16.8634 15.3184C17.054 15.3184 17.2325 15.2445 17.3665 15.1107L17.7923 14.6846C17.9262 14.5507 18 14.3722 18 14.1818C18 13.9913 17.9262 13.8127 17.7923 13.6789L12.002 7.88834C11.8676 7.75422 11.6883 7.68055 11.4976 7.68097C11.3062 7.68055 11.127 7.75422 10.9927 7.88834Z",
  fill: "black"
});

var SvgBlackArrowUp = function SvgBlackArrowUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlackArrowUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/black-arrow-up.a704a077.svg";
export { ForwardRef as ReactComponent };